module.exports = __webpack_public_path__ + "static/media/mohammed.173acdc8.jpg";